import React, { useState } from "react";
import { useProductGroupCategory } from "../../../../api/product-group-category/use-product-group-category";
import Button from "../../../../components/ui/Button/Button";
import { Dropdown } from "../../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../../components/ui/InputDate/InputDate";
import InputSearch from "../../../../components/ui/InputSearch/InputSearch";

const checkByOptions = [
  {
    id: "name",
    name: "상품명",
  },
  {
    id: "productGroupName",
    name: "상품 그룹명",
  },

  {
    id: "productNo",
    name: "상품번호 표시",
  },
];

function Filter(props) {
  const {
    onFilter,
    onSubmitFilter,
    onResetFilter,
    onChangeSearchBy,
    onChangeSearchByValue,
    filter,
  } = props;
  const { data: categories } = useProductGroupCategory();
  const categoriesData = [
    {
      id: "",
      name: "전체",
    },
    ...categories,
  ];
  const [discountStartDate, setDiscountStartDate] = useState(null);
  const [discountEndDate, setDiscountEndDate] = useState(null);
  const [selectedDateOption, setSelectedDateOption] = useState();

  const onChangeDiscountStartDate = (value) => {
    setDiscountStartDate(value);
    onFilter({
      ...filter,
      from: value?.unix(),
    });
  };

  const onChangeDiscountEndDate = (value) => {
    setDiscountEndDate(value);
    onFilter({
      ...filter,
      to: value?.unix(),
    });
  };
  const onChangeDateTo = (increment) => {
    if (discountEndDate !== null) {
      setSelectedDateOption(increment);
      if (increment === 1 || increment === 7) {
        const subtracted = discountEndDate.subtract(increment, "day");
        setDiscountStartDate(subtracted);
        onFilter({
          ...filter,
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }
      if (increment === 30) {
        const subtracted = discountEndDate.subtract(1, "month");
        setDiscountStartDate(subtracted);
        onFilter({
          ...filter,
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }
      if (increment === 90) {
        const subtracted = discountEndDate.subtract(3, "month");
        setDiscountStartDate(subtracted);
        onFilter({
          ...filter,
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }

      if (increment === 180) {
        const subtracted = discountEndDate.subtract(6, "month");
        setDiscountStartDate(subtracted);
        onFilter({
          ...filter,
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }

      if (increment === 365) {
        const subtracted = discountEndDate.subtract(1, "year");
        setDiscountStartDate(subtracted);
        onFilter({
          ...filter,
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }
    }
  };

  return (
    <div
      style={{
        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
      }}
      className="mt-3 rounded-[4px]"
    >
      <div className="flex items-center px-5 pt-5 pb-[10px]">
        <div className="flex items-center">
          <span className="w-24">카테고리</span>
          <Dropdown
            options={categoriesData}
            onClickItem={(id) =>
              onFilter({
                ...filter,
                categoryId: id,
              })
            }
            placeholder="카테고리 선택"
          />
        </div>
      </div>

      <div className="flex items-center px-5 pb-5">
        <div className="flex items-center justify-between gap-[35px]">
          <div className="flex items-center w-1/2">
            <span className="w-24">검색</span>
            <div className="flex gap-4">
              <Dropdown
                width="w-32"
                placeholder="상품명"
                options={checkByOptions}
                onClickItem={onChangeSearchBy}
              />
              <InputSearch onChange={(value) => onChangeSearchByValue(value)} />
            </div>
          </div>

          <div className="flex items-center gap-[4px] w-full">
            <span className="w-12">기간</span>
            <InputDate
              value={discountStartDate}
              onChange={onChangeDiscountStartDate}
              defaultValue={discountStartDate}
            />
            {" - "}
            <InputDate
              value={discountEndDate}
              onChange={onChangeDiscountEndDate}
              defaultValue={discountEndDate}
            />
            <div
              className={`ml-[1rem] border h-8 rounded-[4px] border-button-grey flex divide-x text-[#bbbbbb]`}
            >
              <div
                onClick={() => onChangeDateTo(1)}
                className={`p-2 m-auto cursor-pointer text-[10px] ${
                  selectedDateOption === 1 ? "bg-primary-blue text-white" : ""
                }`}
              >
                오늘
              </div>
              <div
                onClick={() => onChangeDateTo(7)}
                className={`p-2 m-auto cursor-pointer text-[10px] ${
                  selectedDateOption === 7 ? "bg-primary-blue text-white" : ""
                } `}
              >
                7일
              </div>
              <div
                onClick={() => onChangeDateTo(30)}
                className={`p-2 m-auto cursor-pointer text-[10px] ${
                  selectedDateOption === 30 ? "bg-primary-blue text-white" : ""
                }`}
              >
                1개월
              </div>
              <div
                onClick={() => onChangeDateTo(90)}
                className={`p-2 m-auto cursor-pointer text-[10px] ${
                  selectedDateOption === 90 ? "bg-primary-blue text-white" : ""
                } `}
              >
                3개월
              </div>

              <div
                onClick={() => onChangeDateTo(180)}
                className={`p-2 m-auto cursor-pointer text-[10px] ${
                  selectedDateOption === 180 ? "bg-primary-blue text-white" : ""
                }`}
              >
                6개월
              </div>

              <div
                onClick={() => onChangeDateTo(365)}
                className={`p-2 m-auto cursor-pointer text-[10px] ${
                  selectedDateOption === 365 ? "bg-primary-blue text-white" : ""
                }`}
              >
                1년
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-2.5 w-full border-t border-disable-grey " />
      <div className="pb-2.5 flex justify-center items-center">
        <Button
          onClick={onSubmitFilter}
          className="border border-secondary-grey"
          paddingButton="p-1"
          width="w-[7rem]"
          text="필터 검색"
        />

        <Button
          onClick={onResetFilter}
          className="border border-secondary-grey"
          text="필터 초기화"
          width="w-[7rem]"
          paddingButton="p-1"
        />
      </div>
    </div>
  );
}

export default Filter;
